import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { ViewChild, ViewContainerRef, Injectable } from '@angular/core'
import { ItemService } from '../../services/item/item.service';
import { AnswerService } from '../../services/answer/answer.service';
import { RestService } from '../../services/rest/rest.service';
import { AnswerControlService } from '../../services/answer/answerControl.service';
import { Item } from '../../model/item';
import { ReviewTest } from '../../model/reviewTest';
import { Answer } from '../../model/answer';
import { Token } from "../../model/token";
import { TokenService } from "../../services/state/token.service";
import { TokenControlService } from "../../services/state/tokenControl.service";
import { Router } from '@angular/router';
import { EncryptionService } from "../../services/data/encryption.service";
import { CONFIG } from "../../constants/constants";
import { CodResp } from '../../constants/codigosMensajes';
import { StateService } from "../../services/state/state.service";
import { State } from "../../model/state";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { WelcomeDTO } from "../../model/welcome.info";
import { TimeChrono } from "../../model/timeChrono";
import { DeleteService } from "../../services/data/delete.service";
import { LoginService } from '../../services/login/login.service';
import { AddComponentService } from "../../services/addComponent/add-component.service";
import { TranslateService } from '@ngx-translate/core';
import { FooterVisualizerComponent } from '../footer-visualizer/footer-visualizer.component';
import { DatePipe } from '@angular/common';
import { ConfigurationService } from "../../services/configuration/configuration.service";
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { Session } from '../../model/session';
import { ItemControlService } from "../../services/item/item-control.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { ESTADO_SESSION_INFO } from '../../model/estadoSessionInfo';
import { ToolkitService } from "../../services/toolKit/toolkit.service";
import { OfflineService } from '../../services/data/offline.service';
import { NetworkConectionService } from '../../services/network/networkConection.service';
import { Subscription } from 'rxjs';
import { ConectionEnum, ConectionStatusDto } from '../../model/conectionStatus.dto';
import { DateServerService } from '../../services/dateServerService/date-server.service';
import { LtiService } from '../../services/LTI/lti.service';
import { Mask, MaskService } from '../../services/mask/mask.service';
import { ValidacionPcService } from '../../services/validacionPC/validacion-pc.service';
import { NavigateDemoGuard } from '../../guards/navigateDemo.guard';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TYPE_ITEMS } from '../../constants/typeItems';
import { videoDraggable } from '../../components/draggable-functions/draggable-functions';
import { EstadoUsuarioService } from '../../services/estadoUsuario/estadoUsuario.service';
import { ExamEvaluationConfService } from '../../services/examEvaluationConf/examEvaluationConf.service';
import { Timeouts } from '../../../../node_modules/@types/selenium-webdriver';
import { ExamEvaluationValidationResponse } from '../../model/exam-evaluation-configuration';
import { InternetStatusComponent } from '../internet-status/internet-status.component';
import * as FileSaver from 'file-saver';
import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { TYPE_ROLES } from '../../constants/typeRoles';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Variable del global scope para utilizar jquery
declare var $: any;

@Injectable()
export class Globals {
  testChrono: any;
}

@Component({
  selector: 'app-visualizer',
  templateUrl: './visualizer.component.html',
  styleUrls: ['./visualizer.component.css', './image-error.css'],
  providers: [ItemService,
    AnswerService,
    RestService,
    TokenService,
    DeleteService,
    LoginService,
    FooterVisualizerComponent
  ]
})
/*Controlador de la pagina visualizer.html se encarga de la visualizacion
 de los items*/
export class VisualizerComponent implements OnInit, OnDestroy {

  //Inyeccion del componente interno que compilara el html de los items
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container: ViewContainerRef;

  //Item que se muestra en el contenedor
  public actual: Item;

  // public itemFilesEmpty!: Number[] = null
  public itemFilesEmpty!: Number[]

  //Flag que indica si hay conexion a internet o no
  //public online: boolean;

  //Variable para control de respuesta
  public respuesta!: any;

  //El token del usuario que presenta el examen
  private token!: Token;

  //La sesion de la prueba que se esta desarrollando actualmente
  public sesion: number;

  //Indica si todos las respuestan han sido sincronizadas
  public allSynced!: boolean;

  //Numero de item que muestra inicalmente el visualizador
  public initItem: number;

  //Indica si se debe mostrar el boton de finalizar
  public mostrarFinalizar: boolean;

  //Almacena toda la informacion de la pagina de bienvenida
  public welcomeData: WelcomeDTO;

  //Flag de control para mostrar o no el boton de scroll
  //public showScrollBtn: boolean;

  //Ayuda a controlar la posicion del scroll
  public position: number;

  //Captura la respuesta del editor en Respuesta abierta
  public editorContent!: string;

  public rtaArea!: string;

  //Variable auxiliar para saber si una respuesta es marcada o no
  private previousMark: any;

  //Variable auxiliar para conocer la cantidad de ítems que tiene una sesión
  public totalItemsSesion!: Item[];

  //Arreglo que combia datos de ítems con sus respectivas respuestas, para la contrucción de la revisión
  public totalReviewTest!: ReviewTest[];

  //Arreglo que combia datos de ítems con sus respectivas respuestas abiertas, para la contrucción de la revisión
  public totalOpenReviewTest!: ReviewTest[];

  //Flag de control para mostrar o no la revisión de prueba
  public showReview!: Boolean;

  //Captura el objeto para crear el archivo de respuestas
  public textoBlob: any;

  //Captura el string de respuestas
  public stringResp: any;

  //Captura el pasword del delegado
  public passwordDelegado: string | null = null;

  //Captura la respuesta del editor en Respuesta abierta
  public validationPassword!: Boolean;

  //Captura la respuesta del editor en Respuesta abierta
  public validationAnswerSincroniced: Boolean;

  //Muestra el reintento para sincronizar respuestas
  public downloadinProcess: Boolean;

  //captuta el nombre del archivo
  public nameFile!: string;

  //Flag de control para mostrar o no el resumen de respuestas
  public showSummary!: Boolean;

  //Tabla auxiliar, que define los límites (desde-hasta) para mostrar las respuestas en el resumen
  public dataTables!: any[];

  //Tabla auxiliar, para mostrar las respuestas abiertas en el resumen
  public dataTableOpen!: any[];

  //Flag de control que permite finalizar el test, si el evaluado está de acuerdo con el resumen de respuestas
  public checkAgree: any;

  public renderBtn: Boolean;

  public sessionInfo: Session;

  public prueba: string;

  /**Flag que deshabilita el boton de continuar para  evitar doble clic */
  public deshabilitarContinuar: Boolean;

  /**Atributo utilizado para indicar si se debe guardar ´pregunta abierta */
  public tieneCrono: Boolean;

  public disabledNextBack: Boolean;

  public disableEnviarRespuesta: Boolean = false;

  public disabledTimeDefault!: Boolean;

  public disabledEndTest!: Boolean;

  public disableButtonS3: Boolean = false;

  /**Atributo utilizado para visualizar archivo pdf */
  public urlPdfSafe: any;

  /**atributos recibidos lambda S3 */
  public responseLambdaS3: any = {
    numeroRadicado: "",
    fechaCargue: "",
    estado: "",
    nombreArchivo: "",
    statusCode: ""
  };
  public nombreArchivoExtension: string = '';
  public textoencriptadoString: string = '';
  public reintentoEnvioS3: number = 0;

  urlChat: string = '';
  urlSafeChat: SafeResourceUrl | null = null;

  subscriptions: Subscription[] = [];
  isSumadiActive!: Boolean;
  idSession!: number;

  /**Permite mostrar el mensaje inicial para pregunta abierta */
  public msjInicialPreguntaAbierta!: String;

  /**Permite mostrar el mensaje de alerta para pregunta abierta */
  public msjFinalPreguntaAbierta!: String;

  numberTotalAswer!: number;
  totalAnswerEmpty!: number;
  totalAnswerResponse!: number;

  //variable para controlar el panel de evaluacion de prueba
  showPanelEvaluation!: boolean;
  panelEvaluationOffsetTop!: number;

  //variable para mostrar el error en el formulario de evaluacion de item
  examEvaluationResult!: ExamEvaluationValidationResponse;
  @ViewChild(InternetStatusComponent, { static: false }) child: InternetStatusComponent | undefined;

  //Constructor de la clase
  constructor(private _router: Router,
    private cdr: ChangeDetectorRef,
    private _itemService: ItemService,
    private networkConectionService: NetworkConectionService,
    private _answerService: AnswerService,
    private _restService: RestService,
    public _answerController: AnswerControlService,
    public _tokenController: TokenControlService,
    private _encryptionService: EncryptionService,
    public _stateService: StateService,
    private _welcomeDataService: WelcomeService,
    private _loginService: LoginService,
    private _deleteService: DeleteService,
    private _datePipe: DatePipe,
    private _translateService: TranslateService,
    private _configurationService: ConfigurationService,
    public _configurationControlService: ConfigurationControlService,
    private _addComponent: AddComponentService,
    private _spinner: NgxSpinnerService,
    public _itemControlService: ItemControlService,
    private _toolkitService: ToolkitService,
    private _offlineService: OfflineService,
    private _dateServerService: DateServerService,
    private _ltiService: LtiService,
    private _maskService: MaskService,
    private _validacionPcService: ValidacionPcService,
    private sanitizer: DomSanitizer,
    private estadoUsuarioService: EstadoUsuarioService,
    private examEvaluationConfService: ExamEvaluationConfService) {

    this.actual = new Item(0, '', 0, 0, 0, 0, '', '', 0, 0, 0, [], '', '', 0, '');
    this._answerController.started = true;
    this._answerController.progress = 0;
    this._answerController.marcarRespuesta = 0;
    this._answerController.previousAnswer = '';
    this.mostrarFinalizar = false;
    this.welcomeData = this._welcomeDataService.data;
    //this.showScrollBtn = false;
    this.position = 50;
    this.renderBtn = true;
    let self = this;
    this.getPublicIp();
    self.token = _tokenController.token;
    if (this._stateService.state == null || this._stateService.state == undefined) {
      this.sesion = 1;
      this.initItem = 1;
      this._itemService.saveState(new State(1, 1, 1, self.token.credentialId));
    } else {
      this.sesion = self._stateService.state.sesion;
      this.initItem = self._stateService.state.item;
    }
    this.sessionInfo = new Session("", "", new Date(), 0, 0);

    this._translateService.addLangs(["es", "en"]);
    this._translateService.setDefaultLang(_configurationControlService.examConfiguration.language);
    this._translateService.use(_configurationControlService.examConfiguration.language);

    this.validationPassword = false;
    this.validationAnswerSincroniced = false;
    this.downloadinProcess = false;

    this.prueba = "";
    $("#divScroll div").focus();
    this.deshabilitarContinuar = false;
    this.tieneCrono = true;
    this.disabledNextBack = true;
  }

  getItemControlService() {
    return this._itemControlService;
  }

  getAnswerService() {
    return this._answerService;
  }

  getAnswerController() {
    return this._answerController;
  }

  getStateService() {
    return this._stateService;
  }

  getWelcomeDataService() {
    return this._welcomeDataService;
  }

  getConfigurationControlService() {
    return this._configurationControlService;
  }

  /*Metodo encargado de consultar la ip del cliente para almacenarla
  en el objeto respuesta*/
  public getPublicIp() {
    let self = this;
    this._loginService.getIp().then(res => {
      self._configurationControlService.publicIp = res['ip'];
      self._answerController.publicIp = res['ip'];
    })
  }

  private countShoMsjInicialPreguntaAbiertaModal = 0

  /*Necesario debido a la implementacion de la interfaz OnInit
  se ejecuta*/
  ngOnInit() {
    console.log('Configuración backButton:', this._configurationControlService.examConfiguration.backButton);
    this.disabledNextBack = false;
    this._configurationControlService.examConfiguration.backButton = true;
    this.getConfigurationControlService().examConfiguration.securityterri
    this.countShoMsjInicialPreguntaAbiertaModal = 0;
    this.isSumadiActive = this._configurationControlService.examConfiguration.securitySumadi;
    this.idSession = this._ltiService.idSessionStart;
    this.isSumadiActive && !this.idSession ? this.activateSupervision() : this._maskService.setMask(Mask.fullPageMask, false);
    this.isSumadiActive && this.increaseVisorSize()
    this._configurationService.inhabilitarBotonAtras();
    this._configurationControlService.showToolKit = true;
    this.loadWaterMark();
    this._spinner.show();
    $("#divScroll div").focus();
    this.saveState();
    this.loadItemByOrder(this.initItem);
    $("#title").focus();
    $("#modalResume").css("background-repeat", "repeat");
    CONFIG.ONLINE && this.checkNetworkStatus();

    // Inicializar urlSafeChat con un valor seguro por defecto
    this.urlSafeChat = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');

    if (this._configurationControlService.examConfiguration.securityterri == true) {
      this.urlChat = CONFIG.URL_CHAT + "?matricula=" + this._tokenController.token.credentialId
        + "&examen=" + this._welcomeDataService.data.idTerritorium
        + "&appKey=" + CONFIG.APP_KEY;

      this.urlSafeChat = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlChat);
      setInterval(() => {
        //PE-3619 Dragg and drop
        //Valida los movimientos de los eventos mousemove y mouseup para el control del dragg and drop
        //videoDraggable("id-frame-chat-div");

      }, 100);
      if (this._configurationControlService.examConfiguration.securityterri == false) {
        document.getElementById("id-frame-chat-div")!.remove();

      }
    }

    //Valida si es rol evaluador para inicializar el panel
    if (this._tokenController.token.userType == 5) {
      // this.examEvaluationConfService.validationFormReset();
      this.examEvaluationConfService.visualizerComponent = this;
      this.showPanelEvaluation = true;
    }

  }

  ngAfterViewInit() {
    // Inicializar el child component si existe
    setTimeout(() => {
      if (this.child) {
        console.log('InternetStatusComponent inicializado:', this.child.netStatus);
        if (CONFIG.ONLINE) {
          this.child.enableInternetStatus();
        }
      } else {
        console.warn('InternetStatusComponent no está disponible en el template');
      }
    }, 100);
  }

  public saveMensajeRtaAbierta() {
    this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, ESTADO_SESSION_INFO.INICIO_PREGUNTA_ABIERTA);

  }

  increaseVisorSize(): void {
    $('#divScroll').css("height", '800px');
  }

  activateSupervision(): void {
    console.log("ejecutando Post Message => plexiStart");
    window.postMessage({ action: 'plexiStart' }, location.origin)
  }

  checkNetworkStatus(): void {

    const subOnline = this.networkConectionService.onlineEvent.subscribe((e: Event) => {

      const STATUS = this.networkConectionService.createNewStatus(
        this._tokenController.token.credentialId,
        ConectionEnum.CONECTADO,
        this._dateServerService);

      this.networkConectionService.setNewStatus(STATUS);

      if (this.networkConectionService.getNetworkStatuses().length > 0) {

        const TOKEN = this._tokenController.token.token;
        const USER = this._tokenController.token.tokenId;

        this._restService.saveConectionStatus(
          USER,
          TOKEN,
          this.networkConectionService.getNetworkStatuses()
        )
        this.networkConectionService.resetNetworkStatuses();
        // .then(response => {
        //   if (response && response.status === 201) {
        //     this.networkConectionService.resetNetworkStatuses();
        //   }
        // }, e => console.log(e));
      }

    });

    const subOfline = this.networkConectionService.offlineEvent.subscribe((e: Event) => {
      const STATUS = this.networkConectionService.createNewStatus(
        this._tokenController.token.credentialId,
        ConectionEnum.DESCONECTADO,
        this._dateServerService);
      this.networkConectionService.setNewStatus(STATUS);
    });
    this.subscriptions.push(subOnline);
    this.subscriptions.push(subOfline);

  }

  /** Almacena la trazabilidad del examen */
  private saveState() {
    let self = this;
    if (CONFIG.ONLINE) {
      let estado = 0;
      this._configurationControlService.sessionInfo.sesion = this._stateService.state.sesion;
      if (this._configurationControlService.continuarExamen) {
        estado = ESTADO_SESSION_INFO.CONTINUAR_PRUEBA;
      } else {
        estado = ESTADO_SESSION_INFO.INICIAR_PRUEBA;
      }
      this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, estado);
    } else {
      let estado = 0;
      this._configurationControlService.sessionInfo.sesion = this._stateService.state ? this._stateService.state.sesion : 0;
      if (this._configurationControlService.continuarExamen) {
        estado = ESTADO_SESSION_INFO.CONTINUAR_PRUEBA;
      } else {
        estado = ESTADO_SESSION_INFO.INICIAR_PRUEBA;
      }
      self._configurationControlService.sessionEventPile.push({ ...self._configurationControlService.sessionInfo, estado: ESTADO_SESSION_INFO.INICIAR_PRUEBA });
    }

  }

  private extractUrlFromContent(content: string): string {
    // Usa regex para encontrar src dinámicos; ajusta según tu HTML
    const srcMatch = content.match(/src\s*=\s*"([^"]+)"/); // Simple regex para src
    return srcMatch ? srcMatch[1] : '';
  }

  private replaceUrlInContent(content: string, safeUrl: SafeResourceUrl): string {
    // Reemplaza el src con el safe
    return content.replace(/src\s*=\s*"([^"]+)"/, `src="${safeUrl}"`);
  }

  agregarChronoPoint(timeChrono): void {
    let self = this;
    self._configurationControlService.chronoStartAndEnd = [...self._configurationControlService.chronoStartAndEnd, timeChrono];
  }

  /** Metodo encargado de cargar la marca de agua */
  public loadWaterMark() {
    switch (this._configurationControlService.ambiente) {
      case "demo":
        $("#modalResume").css("background-image", "url(/src/app/resources/img/demo.png)");
        break
      case "preIcfes":
        $("#modalResume").css("background-image", "url(/src/app/resources/img/demoPreIcfes.png)");
        break
      case "produccion":
        $("body").attr("style", "background-image:url(" + this._welcomeDataService.waterMark + ") !important;background-repeat:repeat");
        break;
    }
  }

  //Obtiene el valor del atributo respuesta
  public getRespAng(): any {
    return this.respuesta;
  }

  /*Se encarga de establecer el foco en la numeracion de los items
  cuando hay un cambio de item y reiniciar la posicion del scroll
  para que la visualizacion de la pagina este en la parte de arriba*/
  public focusOnItemNumeration() {
    $("#item_numeration").focus();
    window.scrollTo(0, 0);
  }

  //Se encarga de cargar un item segun su orden
  public loadItemByOrder(order: number) {
    this._itemService.actualizarAllRevisionRespuestas(true)
    this.disableElemntsByRol()

    console.log('Cargando item order:', order);
    console.log('renderBtn después de backButtonEnabled:', this.renderBtn);

    this.disabledNextBack = true;
    let self = this;
    if (CONFIG.ONLINE == false) {
      self.sesion = this._tokenController.token.sesion
    }
    this._itemService.getItemByOrder(order, self.sesion).then(result => {
      self._itemControlService.item = result;
      self.actual = result;
      this._itemService.actualizarRevisionRespuesta(result.itemId)
      this._itemService.progressBar = result;

      // if (self.actual.order == self.actual.total) {
      //   self.mostrarFinalizar = true;
      // } else {
      //   self.mostrarFinalizar = false;
      // }

      this.backButtonEnabled(self.actual.order, 0);
      this.disableElemntsByRol()
      self._answerService.getAnswerByMaxDate(self.actual.itemId,
        self._tokenController.token.credentialId
      ).then((res: Answer) => {
        self._answerController.respuesta = res.valorRespuesta;
        self._answerController.itemType = self.actual.type;
        self._answerController.itemId = self.actual.itemId;
        self._answerController.sesion = self.actual.sesion;
        self._answerController.itemOrder = self.actual.order;
        self._answerController.open = res.respuestaAbierta;

        //Valida si es rol evaluador para guardar en la cache la respuesta de la evaluación
        if (this._tokenController.token.userType == 5) {
          this.examEvaluationConfService.validationFormReset();
        }

        if ((self.actual.type == 'open' || self.actual.type == 'open_insor') && res.respuestaAbierta != "") {
          self._answerController.previousAnswer = res.respuestaAbierta;
        } else {
          self._answerController.previousAnswer = res.valorRespuesta;
        }
        self._answerController.marcarRespuesta = res.marcarRespuesta;
        self.previousMark = res.marcarRespuesta;
        self._encryptionService.decrypt_Item(self.actual.content).then(result => {
          self.disabledNextBack = false;
          self.actual.content = result;
          const unsafeUrl = this.extractUrlFromContent(result); // Implementa una función para extraer/reemplazar URLs en el HTML string
          const safeUrl = self.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
          result = this.replaceUrlInContent(result, safeUrl); // Reemplaza en el string HTML
          // ✅ Pasar por sanitizeTemplate de AddComponentService
          result = this._addComponent.sanitizeTemplate(result);
          self._itemControlService.item.contentDecrypted = result;
          self._itemControlService.item = Object.assign({}, self._itemControlService.item);
          let contentSaved = this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId)?.contentDecrypted;
          if (contentSaved != null) {
            self.actual.content = contentSaved
            // self.actual.contentDecrypted = contentSaved;
          }
          self._toolkitService.loadItem(self.actual, result)
          self.actual.contentDecrypted = self._addComponent.addComponent(self.actual.contentDecrypted, self.container, this.actual.itemNumero, self);
          self._addComponent.loadContrast();
          $("img").attr("width", "");
          self._itemService.saveState(new State(self.actual.order, self.actual.sesion, 1, self.token.credentialId));
          //self.checkScroll();
          this._spinner.hide();
          self.configOpenAnswer();
          this.cdr.detectChanges();
          setTimeout(() => $("img").addClass("img-responsive"), 0);
          setTimeout(() => {
            try {
              const botonera = document.querySelector('.bloque-botones') as any;
              if (botonera) {
                const boton = botonera.querySelector('#contenido');
                if (boton) {
                  boton.click();
                  document.querySelector('video')?.pause();
                }
              }
            } catch (e) {
              console.log(e);
            }
          }, 0);
        });
      });
    });
  }

  public disableElemntsByRol() {
    if (this._tokenController.token.userType == TYPE_ROLES.REVIEW) {
      $("input:radio").attr("disabled", true)
      setTimeout(() => {
        $("input:radio").attr("disabled", true)
      }, 1000)
    }
  }


  //Se encarga del guardado de una respuesta
  public saveAnswer() {
    let self = this;
    this.respuesta = this._answerController.getRespuesta();
    this.disableElemntsByRol()
    this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId).respuesta = this.respuesta;
    this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId).marcarRespuesta = this._answerController.marcarRespuesta;
    let answer = new Answer(this.token.credentialId, this.actual.itemId, this._dateServerService.getDateServer(),
      this.respuesta, 'N', self.actual.sesion, self.actual.order,
      self._answerController.publicIp, self._answerController.open,
      self._answerController.marcarRespuesta);
    this._answerService.saveAnswer(answer);
  }

  /*Realiza la búsqueda de respuestas sincronizadas para un id item  de pregunta abierta específico,
    si existe respuesta, se actualiza*/
  public updateOpenAnswer(token: string, answer: Answer, userName: string, idUser: number, isSincronizacion = false) {
    const item: Item = this._itemControlService.totalItems.find(x => x.itemId === answer.itemId);
    if (item) {
      item.respuestaAbierta = answer.respuestaAbierta
      this._answerController.auxOpenAnswerLastLocal = answer.respuestaAbierta
    }
    if (answer.respuestaAbierta == null || (!isSincronizacion && this._answerController.auxOpenAnswer == answer.respuestaAbierta)) {
      return;
    }
    this._restService.updateAnswer(token, answer, userName).then((res: any) => {
      const synchronized = res == CodResp[0].codigo ? 'S' : 'N';
      this._answerService.updateLocalAnswer(answer, synchronized);
      this._answerController.auxOpenAnswer = answer.respuestaAbierta
      if (res == CodResp[26].codigo) {
        $('#finishUsuarioModal').modal({
          show: 'true'
        });
      }

    }).catch(error => this._answerService.updateLocalAnswer(answer, 'N'));

  }

  /**
 * Valida si el usuario ha respondido la pregunta actual
 * @returns true si hay respuesta, false si no la hay
 */
  private hasAnswer(): boolean {
    const currentAnswer = this._answerController.respuesta;
    const currentType = this.actual.type;

    // Para preguntas abiertas (open, open_insor)
    if (currentType === 'open' || currentType === 'open_insor') {
      const openAnswer = this._answerController.open;
      // Limpiar HTML y espacios en blanco
      const cleanAnswer = this.eliminarTag(openAnswer || '').trim();
      return cleanAnswer.length > 0;
    }

    // Para preguntas de archivo
    if (currentType === 'open_file') {
      const file = this._answerController.getFile(
        this._tokenController.token.credentialId,
        this.actual.itemId,
        this.actual.sesion
      );
      return file !== null;
    }

    // Para preguntas de selección múltiple o grilla
    if (this.actual.itemChild > 0) {
      // Tiene sub-ítems (grilla)
      if (!currentAnswer || currentAnswer === 'null') {
        return false;
      }

      const answers = currentAnswer.split('|');
      // Verificar que al menos una respuesta no sea omisión
      return answers.some(ans => ans && ans !== 'O' && ans.trim() !== '');
    }

    // Para preguntas simples (single, insor, etc.)
    return currentAnswer !== null &&
      currentAnswer !== undefined &&
      currentAnswer !== 'O' &&
      currentAnswer !== '' &&
      currentAnswer !== 'null';
  }

  /**
 * Valida que la respuesta abierta tenga al menos 200 caracteres
 * @returns true si cumple el mínimo, false si no
 */
  private hasMinimumCharsInOpenAnswer(): boolean {
    const MIN_CHARS = 200;
    const currentType = this.actual.type;

    // Solo validar para preguntas abiertas
    if (currentType === 'open' || currentType === 'open_insor') {
      const openAnswer = this._answerController.open || '';

      // Limpiar HTML y espacios en blanco
      const cleanAnswer = this.eliminarTag(openAnswer).trim();
      const charCount = cleanAnswer.length;

      console.log('📝 Validación respuesta abierta:', {
        tipo: currentType,
        caracteres: charCount,
        minimo: MIN_CHARS,
        cumple: charCount >= MIN_CHARS
      });

      return charCount >= MIN_CHARS;
    }

    // Para otros tipos de pregunta, no aplicar esta validación
    return true;
  }

  /**
   * Muestra modal de advertencia cuando la respuesta no tiene el mínimo de caracteres
   */
  private showMinCharsWarning(): void {
    const openAnswer = this._answerController.open || '';
    const cleanAnswer = this.eliminarTag(openAnswer).trim();
    const currentCount = cleanAnswer.length;

    // Actualizar el contador en el modal
    const modalCounter = document.getElementById('currentCharCountModal');
    if (modalCounter) {
      modalCounter.textContent = currentCount.toString();
    }

    $('#minCharWarningModal').modal({
      show: 'true'
    });
  }

  /**
   * Muestra modal de advertencia cuando no hay respuesta
   */
  private showNoAnswerWarning(): void {
    $('#noAnswerWarningModal').modal({
      show: 'true'
    });
  }

  //Metodo encargado de la navegacion hacia el item anterior
  public async stepBack() {

    // ✅ NUEVA VALIDACIÓN: Verificar si hay respuesta (opcional)
    if (!this.hasAnswer()) {
      this.showNoAnswerWarning();
      return false;
    }

    //Si es rol evaluador valida que el formulario esté completo
    if (this._tokenController.token.userType == 5) {
      this.examEvaluationResult = this.examEvaluationConfService.validateForm();
      if (!this.examEvaluationResult.status) {
        $('#exam-evaluation-error-form').modal({
          show: 'true'
        });
        return false;
      }
    }

    this.disabledNextBack = true;

    //this.setTimeoutDefaultBotton();
    if (!this._configurationControlService.online) {
      this.guardarRespuestasOffline();
    }

    if (await this.isShowModalLimitCaracteresPA(false)) {
      this.disabledNextBack = false;
      return false
    }

    this.setContentHighLighted();

    //Valida si el rol corresponde a usuario evaluador para guardar la evaluacion
    if (this._tokenController.token.userType === 5) {
      this.saveExamEvaluationItem();
    }
    else {
      this.saveAllAnswers();
    }

    if (this.actual.order == 1) {
      console.log('already first sesion element');
      return;
    }
    // this.backButtonEnabled(this.actual.order, -1);
    this.mostrarFinalizar = false;
    let order = this.actual.order - 1;
    let self = this;
    this._itemService.getItemByOrder(order, self.sesion).then(result => {
      self._itemControlService.item = result;
      self.actual = result;
      let itemId = self.actual.itemId;
      this._itemService.actualizarRevisionRespuesta(itemId)
      self._answerService.getAnswerByMaxDate(itemId,
        self._tokenController.token.credentialId).then((res: Answer) => {
          self._answerController.respuesta = res.valorRespuesta;

          //Valida si es rol evaluador para guardar en la cache la respuesta de la evaluación
          if (this._tokenController.token.userType == 5) {
            this.examEvaluationConfService.validationFormReset();
            this.examEvaluationConfService.setLocalStorage(self.actual.itemId, res.respuestaAbierta);
          }

          self._answerController.open = res.respuestaAbierta;
          self._answerController.itemType = self.actual.type;
          self._answerController.itemId = self.actual.itemId;
          self._answerController.sesion = self.actual.sesion;
          self._answerController.itemOrder = self.actual.order;
          if ((self.actual.type == 'open' || self.actual.type == 'open_insor') && res.respuestaAbierta != "") {
            self._answerController.previousAnswer = res.respuestaAbierta;
          } else {
            self._answerController.previousAnswer = res.valorRespuesta;
          }
          self._answerController.marcarRespuesta = res.marcarRespuesta;
          self.previousMark = res.marcarRespuesta;
          self._encryptionService.decrypt_Item(self.actual.content).then(result => {
            self.disabledNextBack = false;
            self.actual.content = result;
            self._itemControlService.item.contentDecrypted = result;
            self._itemControlService.item = Object.assign({}, self._itemControlService.item);
            let contentSaved = this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId).contentDecrypted;
            if (contentSaved != null) {
              self.actual.content = contentSaved
              // self.actual.contentDecrypted = contentSaved;
            }
            self._toolkitService.loadItem(self.actual, result)
            self.actual.contentDecrypted = self._addComponent.addComponent(self.actual.contentDecrypted, self.container, self.actual.itemNumero, self);
            self._addComponent.loadContrast();
            $("img").attr("width", "");
            self._itemService.saveState(new State(self.actual.order, self.actual.sesion, 1, self.token.credentialId));
            self._stateService.state = new State(self.actual.order, self.actual.sesion, 1, self.token.credentialId);
            //self.checkScroll();
            self.focusOnItemNumeration();
            self.configOpenAnswer();
            self.backButtonEnabled(self.actual.order, 0);
            $("#numbers h6").focus();
            setTimeout(() => $("img").addClass("img-responsive"), 0);
            this.disableElemntsByRol()
            setTimeout(() => {
              try {
                const botonera = document.querySelector('.bloque-botones') as any;
                if (botonera) {
                  const boton = botonera.querySelector('#contenido');
                  if (boton) {
                    boton.click();
                    document.querySelector('video').pause();
                  }
                }
              } catch (e) {
                console.error('Error cargando item anterior:', e);
                self.disabledNextBack = false;
                alert('Error al cargar la pregunta anterior. Por favor, intenta de nuevo.');
              }
            }, 0);
          });
        });
    });
    //this._footer.actualizarInfoProgreso(self.actual.sesion); HU45 porcentaje avance
    this._answerController.open = '';
    this.cdr.detectChanges();
  }

  setTimeoutDefaultBotton() {
    this.disabledTimeDefault = true;
    setTimeout(() => this.disabledTimeDefault = false, 3000);
  }


  //Metodo encargado de la navegacion hacia el item siguiente
  public async stepForward() {

    // ✅ NUEVA VALIDACIÓN: Verificar si hay respuesta
    if (!this.hasAnswer()) {
      this.showNoAnswerWarning();
      return false; // No permite avanzar
    }

    //Si es rol evaluador valida que el formulario esté completo
    if (this._tokenController.token.userType == 5) {
      this.examEvaluationResult = this.examEvaluationConfService.validateForm();
      if (!this.examEvaluationResult.status) {
        $('#exam-evaluation-error-form').modal({
          show: 'true'
        });
        return false;
      }
    }

    this.disabledNextBack = true;
    //this.setTimeoutDefaultBotton();

    if (!this._configurationControlService.online) {
      this.guardarRespuestasOffline();
    }

    if (await this.isShowModalLimitCaracteresPA(false)) {
      this.disabledNextBack = false;
      return false;
    }

    this.setContentHighLighted();

    //Valida si el rol corresponde a usuario evaluador para guardar la evaluacion
    if (this._tokenController.token.userType === 5) {
      this.saveExamEvaluationItem();
    }
    else {
      this.saveAllAnswers();
    }

    if (this.actual.order == this.actual.total - 1) {
      this.mostrarFinalizar = true;
    }

    this._answerController.respuesta = null;
    let order = this.actual.order;

    if (this.actual.order == this.actual.total) {
      this.sesion = this.sesion + 1;
      order = 1;
    } else {
      order = this.actual.order + 1;
    }

    console.log('stepForward - order actual:', this.actual.order, 'nuevo order:', order);

    // this.backButtonEnabled(this.actual.order, 2);

    let self = this;
    this._itemService.getItemByOrder(order, self.sesion).then((result: Item) => {
      self._itemControlService.item = result;
      if (!result || !result.itemId) {
        console.log('no more items...');
        return;
      }
      if (result) {
        self.actual = result;
      }
      let itemId = self.actual.itemId;
      this._itemService.actualizarRevisionRespuesta(itemId)
      self._answerService.getAnswerByMaxDate(itemId,
        self._tokenController.token.credentialId).then((res: Answer) => {
          self._answerController.respuesta = res.valorRespuesta;
          self._answerController.open = res.respuestaAbierta;

          //Valida si es rol evaluador para guardar en la cache la respuesta de la evaluación
          if (this._tokenController.token.userType == 5) {
            this.examEvaluationConfService.validationFormReset();
          }

          self._answerController.itemType = self.actual.type;
          self._answerController.itemId = self.actual.itemId;
          self._answerController.sesion = self.actual.sesion;
          self._answerController.itemOrder = self.actual.order;
          if ((self.actual.type == 'open' || self.actual.type == 'open_insor') && res.respuestaAbierta != "") {
            self._answerController.previousAnswer = res.respuestaAbierta;
          } else {
            self._answerController.previousAnswer = res.valorRespuesta;
          }
          self._answerController.marcarRespuesta = res.marcarRespuesta;
          self.previousMark = res.marcarRespuesta;
          self._encryptionService.decrypt_Item(self.actual.content).then(result => {
            self.disabledNextBack = false;
            self.actual.content = result;
            self._itemControlService.item.contentDecrypted = result;
            self._itemControlService.item = Object.assign({}, self._itemControlService.item);
            let contentSaved = this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId).contentDecrypted;
            if (contentSaved != null) {
              self.actual.content = contentSaved
              // self.actual.contentDecrypted = contentSaved;
            }
            self._toolkitService.loadItem(self.actual, result)
            self.actual.contentDecrypted = self._addComponent.addComponent(self.actual.contentDecrypted, self.container, self.actual.itemNumero, self);
            self._addComponent.loadContrast();
            $("img").attr("width", "");
            self._itemService.saveState(new State(self.actual.order, self.actual.sesion, 1, self.token.credentialId));
            self._stateService.state = new State(self.actual.order, self.actual.sesion, 1, self.token.credentialId);
            //self.checkScroll();
            self.focusOnItemNumeration();
            self.configOpenAnswer();
            $("#numbers h6").focus();
            console.log('stepForward - ANTES de backButtonEnabled, order:', self.actual.order, 'renderBtn actual:', self.renderBtn);
            self.backButtonEnabled(self.actual.order, 0);
            console.log('stepForward - DESPUÉS de backButtonEnabled, renderBtn:', self.renderBtn);
            setTimeout(() => $("img").addClass("img-responsive"), 0);
            this.disableElemntsByRol()
            setTimeout(() => {
              try {
                const botonera = document.querySelector('.bloque-botones') as any;
                if (botonera) {
                  const boton = botonera.querySelector('#contenido');
                  if (boton) {
                    boton.click();
                    document.querySelector('video').pause();
                  }
                }
              } catch (e) {
                console.log(e);
              }
            }, 0);
          });
        });
    });

    //this._footer.actualizarInfoProgreso(self.actual.sesion); HU45 porcentaje avance
    this._answerController.open = '';
    this.cdr.detectChanges();
  }

  private async isActiveMsjFinalrtaAbierta() {
    let isActive = false
    if (this._configurationControlService.examConfiguration.msjFinalrtaAbierta != "" &&
      this._configurationControlService.examConfiguration.msjFinalrtaAbierta != null) {
      if (this._answerController.itemType == 'open' || this._answerController.itemType == 'open_insor') {
        if ((this._answerController.open == "" || this._answerController.open == null)) {
          isActive = true
        }
      } else if (await this.isExistItemTypeOpen() && (this._answerController.auxOpenAnswerLastLocal == "" || this._answerController.auxOpenAnswerLastLocal == null)) {
        isActive = true
      }
    }

    return isActive
  }

  //Se encarga de finalizar un examen
  public async endTest(confirm: Boolean) {
    // ✅ NUEVA VALIDACIÓN: Verificar mínimo de caracteres en preguntas abiertas
    if (!this.hasMinimumCharsInOpenAnswer()) {
      this.showMinCharsWarning();
      return false; // No permite finalizar
    }

    this.disableEnviarRespuesta = true;
    this._spinner.show();
    if (await this.isShowModalLimitCaracteresPA(true)) {
      this._spinner.hide();
      this.disableEnviarRespuesta = false;

      return false
    }

    //Si es rol evaluador valida que el formulario esté completo
    if (this._tokenController.token.userType == 5) {
      this.examEvaluationResult = this.examEvaluationConfService.validateForm();

      if (this.examEvaluationResult.status === true) {
        const respuestasExamEvaluationResult = await this.reviewTest(false);
        const validarExamEvaluationResult = respuestasExamEvaluationResult.some(res => res.answer == false && res.itemId != this.actual.itemId);
        this.examEvaluationResult.message = validarExamEvaluationResult ? 'Debe responder todas las preguntas de la prueba antes de finalizar la sesión' : '';
        this.examEvaluationResult.status = !validarExamEvaluationResult;
      }

      if (!this.examEvaluationResult.status) {
        $('#exam-evaluation-error-form').modal({
          show: 'true'
        });
        this._spinner.hide();
        this.disableEnviarRespuesta = false;

        return false;
      }
      this._spinner.hide();
    }

    try {
      if (!(await this.estadoUsuarioService.getEstadoUsuario(this.token.tokenId, this.token.token))) {
        $('#finishUsuarioModal').modal({ show: 'true' });
        this._spinner.hide();
        this.disableEnviarRespuesta = false;

        return false
      }
    } catch (e) {
      this._spinner.hide();
      this.disableEnviarRespuesta = false
    }

    this._validacionPcService.generarExcelValid(() => { })
    this.borrarCredencialLocal();
    this.validationPassword = false;
    this.passwordDelegado = null;
    this.allSynced = true;
    let this_self = this;

    if (this_self._configurationControlService.online) {
      if (await this.isActiveMsjFinalrtaAbierta()) {
        this.msjFinalPreguntaAbierta = this._configurationControlService.examConfiguration.msjFinalrtaAbierta
        //this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, ESTADO_SESSION_INFO.CIERRE_PREGUNTA_ABIERTA);
      }
      else {
        this.msjFinalPreguntaAbierta = "";
      }

      $('#finishExamModal').modal('hide');

      //Valida si el rol corresponde a usuario evaluador para guardar la evaluacion
      if (this._tokenController.token.userType === 5) {
        this._spinner.hide();
        this.disableEnviarRespuesta = false
        this.saveExamEvaluationItem();

        //abre el cuadro de confirmación de finalización de examen
        $('#finishExamModal').modal({
          show: 'true'
        });

        this.disableEnviarRespuesta = false

        return;
      }

      if (this._answerController.itemType == 'open' || this._answerController.itemType == 'open_insor') {
        this.saveOpenanswer();
        this.tieneCrono = false;
      } else if (this._answerController.respuesta != this._answerController.previousAnswer) {
        this._answerController.previousAnswer = this._answerController.respuesta;
        this.saveAnswer();
      }

      setTimeout(() => {

        this._answerService.getUnsynchronizedAnswers().then(async (result: Answer[]) => {
          this._spinner.hide();
          this.disableEnviarRespuesta = false
          const answers = result.filter((item) =>
            item.credencialId == this._tokenController.token.credentialId
          );
          if (answers.length > 0) {
            try {
              await this._answerService.postSynchronizeAll(this.token.token, answers, this.token.tokenId);
              this.disableEnviarRespuesta = false
            } catch (error) {
              this.validationPassword = true;
              this.allSynced = false;
              this.disableEnviarRespuesta = false
            }
            this.afterEndTest(confirm);
          } else {
            this.afterEndTest(confirm);
          }
        }, (error) => {
          this.disableEnviarRespuesta = false

          console.log(error);
          this._spinner.hide();
          $('#finishExamModal').modal({
            show: 'true'
          });
          this.child?.enableInternetStatus();
        });

      }, 1000);

    } else {

      //Valida si el rol corresponde a usuario evaluador para guardar la evaluacion
      if (this._tokenController.token.userType === 5) {
        this.saveExamEvaluationItem();
      }
      else {
        await this.saveAllAnswers();
      }

      if (confirm) {
        this.downloadinProcess = true;
        let self = this;
        setTimeout(() => {
          self.downloadinProcess = false;
          this.disableEnviarRespuesta = false

        }, 800);
      }
      this._spinner.hide();
      this.disableEnviarRespuesta = false
      this.allSynced = false;

      var banderaModal = $('#downloadPassword:visible').length;
      if (banderaModal === 0) {
        $('#finishExamModal').modal({
          show: 'true'
        });
      }
      this.child?.enableInternetStatus();
    }
  }

  private eliminarTag(mensaje: string): string {
    return mensaje == null
      ? ""
      : mensaje.split("<p>").join("").split("</p>").join("").trim()
  }

  private async getAnswersMaxLimit() {
    const minLetter = this._configurationControlService.examConfiguration.cantidadCaracteresPA
    const totalItems = this.actual.total;
    const sesionActual = this.actual.sesion;
    const answerOpens: Answer[] = []
    try {
      const itemsOpens = (await this._itemService.getItemsBySesion(totalItems, sesionActual)).filter((item: Item) => item.isOpen())
      if (itemsOpens) {
        for (let index = 0; index < itemsOpens.length; index++) {
          const itemOpen = itemsOpens[index]
          const answer = await this._answerService.getAnswerByMaxDate(itemOpen.itemId, this._tokenController.token.credentialId)
          if (answer != null && this.eliminarTag(answer.respuestaAbierta).length < minLetter) {
            answerOpens.push(answer)
          }
        }
      }
    } catch (e) {
      console.error(e);
    }

    return answerOpens
  }

  private async isShowModalLimitCaracteresPA(isFinal: Boolean) {
    let isShow = false
    if (this._configurationControlService.examConfiguration.cantidadCaracteresPA != 0
      && this._configurationControlService.examConfiguration.msjCaracteresPA != ""
    ) {
      const cantidadCaracteresActuales = this._answerController.open == null ? 0 : this.eliminarTag(this._answerController.open).length
      const answerOpenMaxLimit = await this.getAnswersMaxLimit()

      if (((this._answerController.itemType == 'open' && this.sesion == 1 && cantidadCaracteresActuales < this._configurationControlService.examConfiguration.cantidadCaracteresPA)
        || (isFinal && this._answerController.itemOrder == this._answerController.totalItems && answerOpenMaxLimit.length > 0)
      )
        && !this._stateService.endTime
      ) {
        this._configurationControlService.examConfiguration.msjCaracteresPA =
          this._configurationControlService.examConfiguration.msjCaracteresPA.replace("XXX", this._configurationControlService.examConfiguration.cantidadCaracteresPA.toString())

        $('#AlertCaracteresPA').modal({
          show: 'true'
        });
        isShow = true
      }
    }


    return isShow
  }

  /* Se encarga de validar hacia donde debe dirigirse luego de finalizar un test */
  public afterEndTest(confirm: Boolean) {
    if (this._configurationControlService.examConfiguration.summaryTest) {
      if (!confirm && this.actual.totalVisual >= 1) {
        this.showSummay(false);
      } else {
        this.goEndSessionToken();

        $('#finishExamModal').modal('hide');
        $("body").css("background-image", "");
        $("body").css("background-repeat", "repeat");
      }
    } else {
      $('#finishExamModal').modal({
        show: 'true'
      });
    }
  }

  /*Se encarga de la finalizacion de la sesion, borra los datos de
  indexedDB y navega hacia la pagina de informacion final*/
  public goEndSessionTokenDeprecate() {
    this._spinner.show();
    let self = this;
    if (self._configurationControlService.online) {
      if (this.allSynced) {
        this._answerService.saveOmision(this._configurationControlService.online).then(res => {

          let ordenJornada = self.sesion;
          self._loginService.registrarJuramento(this._tokenController.token.token,
            this._tokenController.token.tokenId, ordenJornada
          ).then(res => {

            self._restService.postEndSessionToken(this._tokenController.token.token,
              this._tokenController.token.credentialId,
              self.actual.sesion,
              this._configurationControlService.examConfiguration.sendMail,
              this._welcomeDataService.data, this._tokenController.token.tokenId).then(
                res => {
                  self.finalizeSession();
                }
              );

          });
        });
      } else {
        this.allSynced = false;
      }
    }
    else {
      $('#finishExamModal').modal({
        show: 'true'
      });
    }
  }

  /* Se encarga de la finalizacion de la sesion, borra los datos de
   indexedDB y navega hacia la pagina de informacion final */
  public async goEndSessionToken() {

    this._spinner.show();

    if (this._tokenController.token.userType == 5) {

      await this._restService.postEndSessionToken(
        this._tokenController.token.token,
        this._tokenController.token.credentialId,
        this.actual.sesion,
        this._configurationControlService.examConfiguration.sendMail,
        this._welcomeDataService.data,
        this._tokenController.token.tokenId
      );
      this.finalizeSession();
      this._spinner.hide();
      return;
    }

    if (this._configurationControlService.online) {
      if (this.allSynced) {
        try {
          await this._answerService.saveOmision(this._configurationControlService.online);

          const ordenJornada = this.sesion;
          await this._loginService.registrarJuramento(
            this._tokenController.token.token,
            this._tokenController.token.tokenId,
            ordenJornada
          );

          await this._restService.postEndSessionToken(
            this._tokenController.token.token,
            this._tokenController.token.credentialId,
            this.actual.sesion,
            this._configurationControlService.examConfiguration.sendMail,
            this._welcomeDataService.data,
            this._tokenController.token.tokenId
          );

          this.finalizeSession();
          this._spinner.hide();
        } catch (error) {
          console.error(error);
          this._spinner.hide();
          this._configurationControlService.stopIntervalFlag = true;
          $('#errorBackOrDB').modal({
            show: 'true'
          });
        }
      } else {
        this.allSynced = false;
        this._spinner.hide();
        this._configurationControlService.stopIntervalFlag = true;
        $('#errorBackOrDB').modal({
          show: 'true'
        });
      }
    } else {
      this._spinner.hide();
      $('#finishExamModal').modal({
        show: 'true'
      });
    }
  }

  public loadModalFinishExamModalOffline() {
    this._configurationControlService.online = false;
    setTimeout(function () {
      $('#finishExamModal').modal({
        show: 'true'
      });
    }, 500);

  }


  /*Se encarga de verificar si es necesario mostrar el scroll
  cuando hay un cambio de item*/
  /*public checkScroll() {
    let video = $("video"); video.attr("controlsList", "nodownload");
    //this.showScrollBtn = false;
    let self = this;
    this.position = 50;
    setTimeout(function () {
      let docHeight = $(window).height() * 0.67;
      let divHeight = $("#divScroll").height();
      if (divHeight > docHeight) {
        self.showScrollBtn = true;
      }
      else {
        self.showScrollBtn = false;
      }
    }, 500);
  }*/

  /*Se encarga de mostrar al usuario qué items tienen respuesta y cuáles han sido marcados para revisión;
  también permite el guardado y carca de ítems dentro de la revisión */
  public async callReviewTest(sincronizeAnswers: Boolean) {

    //Si es rol evaluador valida que el formulario esté completo
    if (this._tokenController.token.userType == 5) {
      this.examEvaluationResult = this.examEvaluationConfService.validateForm();
      if (!this.examEvaluationResult.status) {
        $('#exam-evaluation-error-form').modal({
          show: 'true'
        });
        return false;
      }
    }

    this.setTimeoutDefaultBotton();

    if (!this._configurationControlService.online) {
      this.guardarRespuestasOffline();
    }

    try {
      if (!(await this.estadoUsuarioService.getEstadoUsuario(this.token.tokenId, this.token.token))) {
        $('#finishUsuarioModal').modal({ show: 'true' });
        return false
      }
    } catch (e) { }

    this.setContentHighLighted();
    this.reviewTest(sincronizeAnswers).then(res => {
      $('#reviewModal').modal({
        show: 'true'
      });
    })
  }

  public validFileAnswer(item: Item): string {

    const file = this._answerController.getFile(this._tokenController.token.credentialId, item.itemId, item.sesion);

    if (file == null) {
      this.itemFilesEmpty.push(item.orderVisual);
      return 'O';
    } else {
      return 'X';
    }
  }

  public async isExistItemTypeOpen() {
    let isExits = false
    try {
      let itemsFind = await this._itemService.getItemsBySesion(this.actual.total, this.actual.sesion)
      itemsFind.forEach((item) => {
        if (item.type == 'open' || item.type == 'open_insor') {
          isExits = true
        }
      })
    } catch (error) {
      console.error("error en findItemTypeOpen", error)
    }

    return isExits
  }
  /*Encargado de hacer un mapeo entre ítems y respuestas. Utilizado en las funcionalidades de Revisar Prueba y Resumen de respuestas*/
  public async reviewTest(sincronizeAnswers: Boolean): Promise<ReviewTest[]> {

    var totalItems = this.actual.total;
    var sesionActual = this.actual.sesion;
    let self = this;


    if (sincronizeAnswers) {
      //Valida si el rol corresponde a usuario evaluador para guardar la evaluacion
      if (this._tokenController.token.userType === 5) {
        this.saveExamEvaluationItem();
      }
      else {
        await this.saveAllAnswers();
      }
    }
    self.totalReviewTest = [];
    self.totalOpenReviewTest = [];
    self.itemFilesEmpty = [];
    self.totalItemsSesion = await this._itemService.getItemsBySesion(totalItems, sesionActual)
    try {
      self._configurationControlService.examConfiguration.menJurRes = this.openAnswerFormatter(self._configurationControlService.examConfiguration.menJurRes);
      self._configurationControlService.examConfiguration.menResRes = this.openAnswerFormatter(self._configurationControlService.examConfiguration.menResRes);


      for (let index = 0; index < this.totalItemsSesion.length; index++) {
        let item = this.totalItemsSesion[index];

        const res = await this._answerService.getAnswerByMaxDate(this.totalItemsSesion[index].itemId,
          this._tokenController.token.credentialId)

        try {
          let answerOk = false;
          let mark = false;
          let style = "";
          let icon = "";
          let visualConfig = [];
          if (res.marcarRespuesta == 1) {
            mark = true;
          }

          if (item.itemChild != 0) {
            let respuestas = this.createArrayAnswers(res.valorRespuesta, item.itemChild, item.type);
            for (let indice = 0; indice < respuestas.length; indice++) {
              if (respuestas[indice] != '' && !respuestas[indice].includes("O")) {
                answerOk = true;
              } else {
                answerOk = false;
              }
              visualConfig = this.getIconString(answerOk, mark);
              style = visualConfig[0];
              icon = visualConfig[1];

              let reviewAux = this.createReviewObj(item, respuestas[indice], answerOk, mark, style, icon, indice);
              self.totalReviewTest.push(reviewAux);
              self.totalReviewTest.sort(function (a, b) {
                return (a.order - b.order);
              });
            }
          } else {
            if ((res.respuestaAbierta != null && res.respuestaAbierta != '') || res.valorRespuesta != null && !res.valorRespuesta.includes("O")) {
              answerOk = true;
            }
            switch (item.type) {
              case 'open':
              case 'open_insor':
                res.valorRespuesta = this.openAnswerFormatter(res.respuestaAbierta);
                break;
              case "open_file":
                res.valorRespuesta = this.validFileAnswer(item);
                if (res.valorRespuesta == 'X') {
                  answerOk = true;
                }
                break;
            }
            visualConfig = this.getIconString(answerOk, mark);
            style = visualConfig[0];
            icon = visualConfig[1];
            let reviewObj = this.createReviewObj(item, res.valorRespuesta, answerOk, mark, style, icon, 0);
            if (item.type === "open_insor" || item.type === "open") {
              this.totalOpenReviewTest.push(reviewObj);
              this.totalOpenReviewTest.sort(function (a, b) {
                return (a.order - b.order);
              });
            }
            self.totalReviewTest.push(reviewObj);
            self.totalReviewTest.sort(function (a, b) {
              return (a.order - b.order);
            });
          }

        } catch (e) { console.error(e) }
      }//fin for

      this.generarTablaRespuestas()
      this.generarTablaRespuestaAbierta()

    } catch (e) { console.error(e) }

    return this.totalReviewTest
  }

  private generarTablaRespuestaAbierta() {
    //Armar tabla respuestas abiertas
    this.dataTableOpen = [];

    for (let i = 0, itemOpen = null; i < this.totalOpenReviewTest.length; i++) {
      itemOpen = this.totalOpenReviewTest[i];
      if (!itemOpen.answerValue || itemOpen.answerValue == '') {
        this.totalAnswerEmpty++;
      }
      else {
        this.totalAnswerResponse++;
      }

      this.dataTableOpen.push({ "item": itemOpen });
    }

    this.numberTotalAswer = this.totalAnswerEmpty + this.totalAnswerResponse;
  }

  private generarTablaRespuestas() {
    //Armar tabla respuestas cerradas
    this.dataTables = [];
    let aux = 0;
    let items = [];
    this.totalAnswerEmpty = 0;
    this.totalAnswerResponse = 0;
    for (let i = 0; i < this.totalReviewTest.length; i++) {
      const item = this.totalReviewTest[i];
      if ([TYPE_ITEMS.OPEN, TYPE_ITEMS.OPEN_INSOR].includes(item.type.toLocaleLowerCase())) {
        continue
      }

      aux++;
      if (!item.answerValue || item.answerValue == 'O' || item.answerValue == '') {
        this.totalAnswerEmpty++;
      }
      else {
        this.totalAnswerResponse++;
      }

      items.push(item);
      if (aux % 15 == 0) {
        this.dataTables.push({ "items": items });
        items = [];
        aux = 0;
      }
    }

    if (aux > 0) {
      this.dataTables.push({ "items": items });
    }

  }

  /*Permite marcar o desmarcar un ítem para revisión */
  public markAnswer() {
    if (this._answerController.marcarRespuesta == 0) {
      this._answerController.marcarRespuesta = 1;
      this.previousMark = 0;
    } else {
      this._answerController.marcarRespuesta = 0;
      this.previousMark = 1;
    }
    this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId).marcarRespuesta = this._answerController.marcarRespuesta;
  }

  /*Permite navegar a un ítem específico desde la revisión de prueba*/
  gotoItem(item: any) {
    let self = this;
    self.actual.orderVisual = item.orderVisual;
    if (item.order == self.actual.total) {
      this.mostrarFinalizar = true;
    } else {
      this.mostrarFinalizar = false;
    }
    this.loadItemByOrder(item.order);
    $('#reviewModal').modal('hide');
  }

  /*Realiza validaciones previas a la inserción de las respuestas */
  async saveAllAnswers() {
    let onlie = CONFIG.ONLINE;
    if (!onlie) {
      this.validateAnswerOffline();
    } else {
      if (this._configurationControlService.examConfiguration.chrono && this.tieneCrono) {
        this.saveTimeChrono();
      }
      if ((this._answerController.respuesta != this._answerController.previousAnswer && this.actual.type != 'open' && this.actual.type != 'open_insor') ||
        (this._answerController.open != this._answerController.previousAnswer && (this.actual.type == 'open' || this.actual.type == 'open_insor')) ||
        (this._answerController.marcarRespuesta != this.previousMark)) {
        if (this.actual.type == 'open' || this.actual.type == 'open_insor') {
          let answerValue = this._answerController.getRespuesta();
          let answer = new Answer(this._tokenController.token.credentialId,
            this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
            this._answerController.sesion, this._answerController.itemOrder,
            this._answerController.publicIp, this._answerController.open,
            this._answerController.marcarRespuesta);
          if (this._answerController.auxOpenAnswer != this._answerController.open) {
            this._answerController.previousAnswer = this._answerController.open;
            this._answerService.saveAnswer(answer);
          }
        } else {
          this._answerController.previousAnswer = this._answerController.respuesta;
          this.saveAnswer();
        }
      }

      setTimeout(() => {
        this.sincronizacionAllItmes()
      }, 100)

    }
  }

  private postAnswer(answer: Answer) {
    return this._restService.postSynchronize(this.token.token, answer, this.token.tokenId).then((responseAnswer) => {
      if (responseAnswer == CodResp[26].codigo) {
        $('#finishUsuarioModal').modal({
          show: 'true'
        });
      }
      const synchronized = responseAnswer == CodResp[0].codigo ? 'S' : 'N';
      this._answerService.updateLocalAnswer(answer, synchronized);
    })
  }

  public sincronizacionAllItmes() {
    this._answerService.getUnsynchronizedAnswers().then(async (answerUnsyn: Answer[]) => {
      const answerUnsynUser = answerUnsyn.filter((item) => item.credencialId == this._tokenController.token.credentialId);
      for (const answer of answerUnsynUser) {
        const item: Item = this._itemControlService.totalItems.find(x => x.itemId === answer.itemId);
        if (item != null && (item.type == 'open' || item.type == 'open_insor')) {
          await this.updateOpenAnswer(this._tokenController.token.token, answer, this._tokenController.token.tokenId, this._tokenController.token.credentialId, true);
        } else {
          await this.postAnswer(answer)
        }
      }
    });

  }
  validateAnswerOffline() {
    let online = CONFIG.ONLINE
    if ((this._answerController.respuesta != this._answerController.previousAnswer && this.actual.type != 'open') ||
      (this._answerController.open != this._answerController.previousAnswer && (this.actual.type == 'open' || this.actual.type == 'open_insor')) ||
      (this._answerController.marcarRespuesta != this.previousMark)) {
      let this_self = this;
      if (this.actual.type == 'open' && online) {
        let answerValue = this._answerController.getRespuesta();
        let answer = new Answer(this._tokenController.token.credentialId,
          this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
          this._answerController.sesion, this._answerController.itemOrder,
          this._answerController.publicIp, this._answerController.open,
          this._answerController.marcarRespuesta);
        this.updateOpenAnswer(this._tokenController.token.token, answer, this._tokenController.token.tokenId, this._tokenController.token.credentialId);
      } else {
        this._answerController.previousAnswer = this._answerController.respuesta;
        this.saveAnswer();
      }
    }
  }

  //Crea el archivo consultando las respuestas que no han sido sincronizadas en BD y arma la cadena y la envia a encriptar
  public createFile() {
    this.disableButtonS3 = true;
    let this_self = this;
    this.validationPassword = false;
    this.validationAnswerSincroniced = false;
    this.stringResp = [];
    var textoencriptado: any = [];
    var tokenController: any = this_self._tokenController;
    const fechaActual = new Date();
    const anio = fechaActual.getFullYear();
    const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
    const dia = fechaActual.getDate().toString().padStart(2, '0');
    const fechaString = `${anio}${mes}${dia}`;

    if (CONFIG.ONLINE) {
      this.nameFile = tokenController.token.tokenId + "_" + this_self.sesion + "_" + fechaString;
    } else {
      this.nameFile = (this._offlineService.credential.usuario + "_" + this_self.sesion).toLocaleLowerCase();
    }
    if (this.passwordDelegado != null && this.passwordDelegado == CONFIG.PASSWORD_CHANGE_NAME) {
      if (this.actual.type == 'open' || this.actual.type == 'open_insor') {
        let answer = new Answer(this.token.credentialId, this.actual.itemId, this._dateServerService.getDateServer(), 'O', 'N', this_self.actual.sesion, this_self.actual.order,
          this_self._answerController.publicIp, this_self._answerController.open,
          this_self._answerController.marcarRespuesta);
        this.buildStringResp(answer);
        this.verificarEncriptar(textoencriptado);
      } else {
        if (this._tokenController.token.userType !== 5) {
          this._answerService.saveOmision(this._configurationControlService.online).then(res => {
            this_self._answerService.getUnsynchronizedAnswers().then((result: Answer[]) => {
              const answers = result.filter((item) =>
                item.credencialId == this._tokenController.token.credentialId
              );
              for (let answer of answers) {
                this.buildStringResp(answer);
              }
              this.verificarEncriptar(textoencriptado);
            },
              err => {
                console.log("todas sincronizadas");
              });

          })
        } else {
          this_self._answerService.getUnsynchronizedAnswers().then((result: Answer[]) => {
            const answers = result.filter((item) =>
              item.credencialId == this._tokenController.token.credentialId
            );
            for (let answer of answers) {
              this.buildStringResp(answer);
            }
            this.verificarEncriptar(textoencriptado);
            this.disableButtonS3 = false;
          },
            err => {
              console.log("todas sincronizadas");
              this.disableButtonS3 = false;
            });
        }
      }
    } else if (this.passwordDelegado != null && this.passwordDelegado != CONFIG.PASSWORD_CHANGE_NAME) {
      this.validationPassword = true;
    }
    this.disableButtonS3 = false;
  }

  private verificarEncriptar(textoencriptado: any) {
    let self = this;
    if (this.stringResp.length > 0) {
      console.log(this.stringResp);
      this.encryptContent(this.nameFile, textoencriptado);
    }
    else {
      this.validationAnswerSincroniced = true;
      this._deleteService.deleteDatabase().then(result => {
        console.log('DELETE ITEMS DONE');
        self._router.navigate(['/endTest']);
        $("#downloadPassword").modal('hide');
      });

    }
  }

  private buildStringResp(answer: Answer) {
    this.stringResp.push(answer.credencialId + '##' + answer.itemId + '##' + this._datePipe.transform(answer.fechaRespuesta, 'yyyy-MM-dd HH:mm:ss') + '##' + answer.valorRespuesta +
      '##' + answer.itemOrden + '##' + answer.sesion + '##' + answer.ipPublica + '##' + answer.respuestaAbierta + '##');
    this.stringResp.push('¬|¬');
  }

  private cleanChrono(chronoArray: any[]): any {
    return chronoArray.filter(c => c.sesion == this._configurationControlService.sessionInfo.sesion);
  }

  //Esté método encripta el contenido de la cadena generada , crea el archivo y lo descarga
  public encryptContent(nombreArchivo: string, textoencriptado: any) {
    let this_self = this;
    this._configurationControlService.sessionEventPile.push({ ...this._configurationControlService.sessionInfo, estado: ESTADO_SESSION_INFO.FINALIZA_PRUEBA });
    let timeChrono = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
    timeChrono ? timeChrono.timeChrono ? this.agregarChronoPoint(timeChrono) : null : null

    let objToEncript = {
      "stringResp": this_self.stringResp.toString(),
      "eventHistory": this_self._configurationControlService.sessionEventPile,
      "chrono": this.cleanChrono(this_self._configurationControlService.chronoStartAndEnd)
    }
    this._encryptionService.encrypt_data_file(JSON.stringify(objToEncript)).then(res => {
      var json_key = null;
      var string_key = null;
      var ss = crypto.subtle.exportKey("jwk", this._encryptionService.key);
      ss.then(result => {
        json_key = result;
        string_key = JSON.stringify(json_key);
        textoencriptado.push(this._encryptionService.vectorIV + CONFIG.SEPARATOR_ENCRIP);
        textoencriptado.push(result.k + CONFIG.SEPARATOR_ENCRIP);
        textoencriptado.push(res);
        this.textoencriptadoString = '';
        textoencriptado.forEach(valor => {
          this.textoencriptadoString += valor;
        });
        this.nombreArchivoExtension = nombreArchivo.toUpperCase() + ".plx";

        if (!navigator.onLine) {
          this.textoBlob = new Blob([this.textoencriptadoString], {
            type: 'application/octet-stream'
          });
          FileSaver.saveAs(this.textoBlob, this.nombreArchivoExtension);
          $('#downloadPassword').modal('hide');
        } else {
          this.reintentoEnvioS3 = this._configurationControlService.reintentosServiceLambda + 1;
          this.sendFile(this.nombreArchivoExtension, this.textoencriptadoString);
        }
      }, err => {
        console.log('Error obteniendo key');
      })

    }, err => {
      console.log("Error encriptando el contenido del archivo:: " + err);
    })
    this._configurationControlService.sessionEventPile = [];
    this_self._configurationControlService.chronoStartAndEnd = [];
  }

  //Crea el archivo mediante el Blob creado y lo descarga
  public async sendFile(nombreArchivo: string, contenidoArchivo: string) {
    this.disableButtonS3 = true;
    // Specify the name of the file to be saved
    try {
      let responseLambdaS3Await = await this._restService.uploadLambdaS3Contingencia(
        this._tokenController.token.uuidSesion,
        nombreArchivo,
        contenidoArchivo,
        this._tokenController.token.tokenId);

      if (responseLambdaS3Await.statusCode != 200) {
        throw new Error();
      }

      this.responseLambdaS3 = responseLambdaS3Await;

      this.goToResponseSuccess(true);
      this.disableButtonS3 = false;
    } catch (error) {
      this.reintentoEnvioS3--;
      this.goToResponseSuccess(false);
      this.disableButtonS3 = false;
    }

    this.disableButtonS3 = false;
  };

  /*Método que se encarga de borrar los datos de
  indexedDB y navega hacia la pagina de informacion final*/
  public goToResponseSuccess(response: Boolean) {
    $("#downloadPassword").modal('hide');

    if (response) {
      $("#modalErrorReintentos").modal('hide');
      $("#modalCargueS3Exitoso").modal({
        show: 'true'
      });
    }
    else {
      $("#modalErrorReintentos").modal({
        show: 'true'
      });
    }
  }

  public habilitarModalOPrueba() {
    if (this._stateService.endTime && !($('#finishExamModal:visible').length == 1)) {
      $("#finishExamModal").modal({
        show: 'true'
      });
    }
  }

  //Descarga soporte de cargue S3
  public downloadSupportS3() {
    let nombreArchivoPDF = this.responseLambdaS3.nombreArchivo.slice(0, -4);
    const documentDefinition = {
      content: [
        {
          text: 'Cargado con éxito',
          bold: true,
          fontSize: 16,
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        {
          text: 'Estimado jefe de salon, el guardado de archivo de respuestas fue exitoso y se genera el siguiente soporte:'
        },
        {
          columns: [
            [{
              text: '\n'
            },
            {
              text: 'Número de la transacción: ' + this.responseLambdaS3.numeroRadicado,
            },
            {
              text: 'Estado transacción: ' + this.responseLambdaS3.estado,
            },
            {
              text: 'Nombre del Archivo: ' + this.responseLambdaS3.nombreArchivo,
            },
            {
              text: 'Fecha: ' + this.responseLambdaS3.fechaCargue,
            }
            ],
            [
              // Document definition for Profile pic
            ]
          ]
        },
        {
          canvas: []
        },
      ],
      pageMargins: [0, 0, 0, 20],
      // styles: {
      //   name: {
      //     fontSize: 16,
      //     bold: true
      //   }
      // }
    };
    pdfMake.createPdf(documentDefinition).getBlob((blob) => {
      FileSaver.saveAs(blob, nombreArchivoPDF);
    });
  };

  /*Método que se encarga de borrar los datos de
indexedDB y navega hacia la pagina de informacion final*/
  public goFinishBrowser() {
    let self = this;
    self._deleteService.deleteDatabase().then(result => {
      self._router.navigate(['/endTest']);
    });
  }


  //Crea el archivo mediante el Blob creado y lo descarga
  public downloadFile(nombreArchivo: string) {
    // Specify the name of the file to be saved
    var fileNameToSaveAs = nombreArchivo + ".plx";
    var downloadLink = document.createElement("a");
    //downloadLink.contentEditable="pruebas";
    downloadLink.download = fileNameToSaveAs;
    downloadLink.innerHTML = "My Hidden Link";
    downloadLink.href = window.URL.createObjectURL(this.textoBlob);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    this._configurationControlService.downloadFile = true;
    this.goDeleteBDBrowser();
  };


  /*Método que se encarga de borrar los datos de
  indexedDB y navega hacia la pagina de informacion final*/
  public goDeleteBDBrowser() {
    let self = this;
    $("#downloadPassword").modal('toggle');
    self._deleteService.deleteDatabase().then(result => {
      self._router.navigate(['/endTest']);
    });
  }

  /*Se encarga de mostrar al usuario el resumen de respuestas*/
  public showSummay(sincronizeAnswers: Boolean) {
    this.reviewTest(sincronizeAnswers).then(res => {
      $('#summaryView').modal({
        show: 'true'
      });
    })
  }

  public habilitarCertificadoAsistencia() {
    const lastSesion = Math.max(...this.welcomeData.sessions.map(o => Number(o.order)));
    if (this._configurationControlService.examConfiguration.downloadCertificado && ((this.sesion == 1 && this._configurationControlService.examConfiguration.multiplesesion == false) || this.sesion == lastSesion)) {
      return true;
    }
    return false;
  }


  /*Método que se encarga de descargar el certificado de asistencia*/
  public async downloadAttendanceCertificate() {

    if (this.habilitarCertificadoAsistencia()) {

      this._spinner.show();
      try {

        const auth1 = await this._restService.prismaAutenticacacionTransversal();
        const habilitarCertificado = await this._restService.prismaHabilitarCertificado(auth1.token, this._tokenController.token.snp.toUpperCase());

        const certificado = await this._restService.prismaCertificadoAsistencia(
          auth1.token,
          habilitarCertificado.numeroDocumento,
          habilitarCertificado.tipoDocumento,
          habilitarCertificado.fechaNacimiento,
          habilitarCertificado.periodo,
          habilitarCertificado.idExamenAplicacion
        );

        const uint8Array = new Uint8Array(certificado); // Convierte el ArrayBuffer a un Uint8Array
        const base64String = btoa(String.fromCharCode.apply(null, uint8Array)); // Convierte a base64

        const auth2 = await this._restService.prismaAutenticacacionTransversal();
        const certificadoFirmado = await this._restService.prismaFirmaApostilla(auth2.token, 6, 'INSTITUCION', base64String);

        const fileUrl = "data: application/pdf;base64," + certificadoFirmado.file;
        fetch(fileUrl)
          .then(response => response.blob())
          .then(blob => {
            var link = window.document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Certificado.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this._spinner.hide();
          });

        await this._restService.registrarCertificadoAsistencia(this._tokenController.token.token, this._tokenController.token.tokenId, this.sesion);

      } catch (error) {
        console.log(error)
        this._spinner.hide();
      }
    }
  }

  public async validateEndSummary() {

    let this_self = this;
    if (this_self._configurationControlService.online) {
      //Valida si es rol evaluador para finalizar la sesión
      if (this._tokenController.token.userType == 5) {
        this.finalizeSession();
      }
      else {
        await this.goEndSessionToken();
        await this.downloadAttendanceCertificate();
      }

    } else {
      this.endTest(true);
    }
  }

  //Validación de estados para habilitar el botón de
  public backButtonEnabled(order: number, direction: number) {
    console.log('Calculando backButtonEnabled - order:', order, 'Total:', this.actual?.total);

    // Botón "Anterior" - mostrar solo si NO estamos en la primera pregunta
    this.renderBtn = (order > 1);

    // Botón "Finalizar" - mostrar SOLO si estamos en la ÚLTIMA pregunta
    // Verificar que actual exista antes de acceder a sus propiedades
    if (this.actual && this.actual.total) {
      this.mostrarFinalizar = (order >= this.actual.total);
    } else {
      this.mostrarFinalizar = false;
    }

    console.log('Resultado -> renderBtn (Anterior):', this.renderBtn, '| mostrarFinalizar:', this.mostrarFinalizar);
    console.log('📊 Datos -> order:', order, 'total:', this.actual?.total);
    this.cdr.detectChanges();
  }


  //Método encargado de guardar el estado del cronómetro
  public saveTimeChrono() {
    let timeChrono = new TimeChrono(this._tokenController.token.credentialId, JSON.stringify(this._stateService.timeChrono), new Date(), this._stateService.state.sesion);
    this._restService.saveTestChrono(this._tokenController.token.token, timeChrono, this._tokenController.token.tokenId);
  }

  public configOpenAnswer() {
    if (this.countShoMsjInicialPreguntaAbiertaModal < 1 && (this.actual.type == 'open' || this.actual.type == 'open_insor') && this._configurationControlService.examConfiguration.msjInicialrtaAbierta != "" && this._configurationControlService.examConfiguration.msjInicialrtaAbierta != null) {
      $('#msjInicialPreguntaAbiertaModal').modal({ show: 'true' })
      this.msjInicialPreguntaAbierta = this._configurationControlService.examConfiguration.msjInicialrtaAbierta
      this.countShoMsjInicialPreguntaAbiertaModal++
    }
    let self = this;
    setTimeout(function () {
      if (self.actual.type == 'open' || self.actual.type == 'open_insor') {
        $("body").find("iframe").attr('id', 'idframe')
        $("#idframe").contents().find("body").attr('onpaste', 'return false')
        $("#idframe").contents().find("body").attr('id', 'bodyIframe')
        $("#idframe").contents().find("#bodyIframe").keyup(function () {
          let maxlength = 2700;
          let totalWords = $("#idframe").contents().find("#bodyIframe p").text().length;
          $("#idframe").contents().find("#bodyIframe p").text()
          this._answerController.auxOpenAnswerLastLocal = $("#idframe").contents().find("#bodyIframe p").text()
          if (totalWords >= maxlength) {
            $("#modalChar").modal("show");
          }
        });
      }
    }, 1000);

  }

  /** Método encargado de actualizar pregunta abierta al finalizar el examen */
  public saveOpenanswer() {
    this._answerController.auxOpenAnswerLastLocal = this._answerController.open
    if (this._answerController.auxOpenAnswer == this._answerController.open && (this._answerController.itemType == 'open' || this._answerController.itemType == 'open_insor')) {
      return;
    }
    let answerValue = this._answerController.getRespuesta();
    let answer = new Answer(this._tokenController.token.credentialId,
      this._answerController.itemId, this._dateServerService.getDateServer(), answerValue, 'N',
      this._answerController.sesion, this._answerController.itemOrder,
      this._answerController.publicIp, this._answerController.open,
      this._answerController.marcarRespuesta);


    this._restService.updateAnswer(this._tokenController.token.token, answer, this._tokenController.token.tokenId).then((res: any) => {
      const synchronized = res == CodResp[0].codigo ? 'S' : 'N';
      this._answerService.updateLocalAnswer(answer, synchronized);
      this._answerController.auxOpenAnswer = this._answerController.open
    });
  }

  private createReviewObj(item: Item, respuesta: string, answer: Boolean, mark: Boolean, style: string, icon: string, indiceSubItem: number): ReviewTest {
    let reviewObj = new ReviewTest(item.itemId, item.content,
      item.orderVisual + indiceSubItem, item.sesion, item.sesions,
      item.total, item.testName, item.type,
      item.itemChild, item.order, item.totalVisual,
      answer, mark, style, icon, respuesta);
    return reviewObj;
  }

  private createArrayAnswers(answerComplete: string, indiceSubItem: number, itemType: string): string[] {
    let answersChilds = [];
    let answersBySubItem = [];
    let auxAnswers = [];
    if (answerComplete != null && answerComplete.length > 0) {
      answersBySubItem = answerComplete.split('|');
      for (let j = 0; j < indiceSubItem; j++) {
        if (answersBySubItem[j] != 'O') {
          if (itemType == 'ing_p2' || itemType == 'grid') {
            auxAnswers = answersBySubItem[j].split('*');
          } else {
            auxAnswers = answersBySubItem[j].split('-');
          }
          answersChilds.push(auxAnswers[1]);
        } else {
          answersChilds.push('');
        }
      }
    } else {
      for (let index = 0; index < indiceSubItem; index++) {
        answersChilds.push('');
      }
    }
    return answersChilds
  }

  private getIconString(answer: Boolean, mark: Boolean): string[] {
    let visualConfig = [];
    if (!answer && !mark) {
      visualConfig.push('sin-responder-btn');
      visualConfig.push('');
    } else if (answer && !mark) {
      visualConfig.push('respondida-btn');
      visualConfig.push('');
    } else if (!answer && mark) {
      visualConfig.push('sin-responder-btn');
      visualConfig.push('ico-bookmark');
    } else if (answer && mark) {
      visualConfig.push('respondida-btn');
      visualConfig.push('ico-bookmark');
    }
    return visualConfig;
  }

  private createGridAnswer(answerComplete: string): string {
    let answer2show: string;
    answer2show = '';
    let answersBySubItem = [];
    let auxAnswers = [];
    if (answerComplete != null && answerComplete.length > 0) {
      answersBySubItem = answerComplete.split('|');
      for (let j = 0; j < answersBySubItem.length; j++) {
        auxAnswers = answersBySubItem[j].split('*');
        if (auxAnswers[0] != 'O') {
          answer2show += auxAnswers[1] + '-';
        } else {
          answer2show += auxAnswers[0] + '-';
        }
      }
      answer2show = answer2show.substr(0, answer2show.length - 1);
    }
    return answer2show;
  }

  private openAnswerFormatter(openAnswer: string): string {
    openAnswer = openAnswer ? String(openAnswer).replace(/&nbsp;/gm, '') : '';
    return openAnswer ? String(openAnswer).replace(/<[^>]+>/gm, '') : '';
  }

  /** Encargado de guardar el contenido subrayado segun idItem */
  private setContentHighLighted() {
    const item = this._itemControlService.totalItems.find(x => x.itemId === this.actual.itemId)
    item.contentDecrypted = this.getCotentHighLighted(item)
  }

  /** Encargado de capturar el contenido subrayado del item */
  private getCotentHighLighted(item: Item) {
    var contentDecrypted = item.contentDecrypted
    const itemUpdate = this._toolkitService.getItemUpdate()
    if (itemUpdate && item.itemId == itemUpdate.itemId) {
      contentDecrypted = itemUpdate.contentDecrypted
    }

    return contentDecrypted
  }

  /** Encargado de guardar respuestas en localhost */
  private guardarRespuestasOffline() {

    this.allSynced = false;
    let this_self = this;
    this.validationPassword = false;
    this.validationAnswerSincroniced = false;
    this.stringResp = [];
    var textoencriptado: any = [];
    var tokenController: any = this_self._tokenController;
    const fechaActual = new Date();
    const anio = fechaActual.getFullYear();
    const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
    const dia = fechaActual.getDate().toString().padStart(2, '0');
    const fechaString = `${anio}${mes}${dia}`;

    if (CONFIG.ONLINE) {
      this.nameFile = tokenController.token.tokenId + "_" + this_self.sesion + "_" + fechaString;
    } else {
      this.nameFile = (this._offlineService.credential.usuario + "_" + this_self.sesion).toLocaleLowerCase();
    }
    if (this.actual.type == 'open') {
      let answer = new Answer(this.token.credentialId, this.actual.itemId, this._dateServerService.getDateServer(), 'O', 'N', this_self.actual.sesion, this_self.actual.order,
        this_self._answerController.publicIp, this_self._answerController.open,
        this_self._answerController.marcarRespuesta);
      this.buildStringResp(answer);
      this.encryptContentGuardadoOffline();
    } else {
      this.encryptContentGuardadoOffline();
    }
  }

  public encryptContentGuardadoOffline() {
    let this_self = this;
    this_self._answerService.getUnsynchronizedAnswers().then((result: Answer[]) => {
      const answers = result.filter((item) =>
        item.credencialId == this._tokenController.token.credentialId
      );
      let objetoAEncriptar = { "answers": answers, "crono": this_self._stateService.timeChrono };
      let respuestasJson = JSON.stringify(objetoAEncriptar);
      this.encriptarRespuetasParcial(respuestasJson);
    }, err => {
      console.log(err);
    });
  }

  private encriptarRespuetasParcial(textoParaEncriptar: any) {
    let this_self = this;
    this._encryptionService.encrypt_data_file(textoParaEncriptar).then(res => {
      var json_key = null; var string_key = null;
      let textoEncriptado: any = [];
      var ss = crypto.subtle.exportKey("jwk", this._encryptionService.key);
      ss.then(result => {
        json_key = result;
        string_key = JSON.stringify(json_key);
        textoEncriptado.push(this_self._encryptionService.vectorIV + CONFIG.SEPARATOR_ENCRIP);
        textoEncriptado.push(result.k + CONFIG.SEPARATOR_ENCRIP);
        textoEncriptado.push(res);
        window.localStorage.setItem(
          this._tokenController.token.credentialId.toString(),
          JSON.stringify(textoEncriptado)
        );
      }, err => {
        console.log('Error obteniendo key');
      });
    }, err => {
      console.log("Error encriptando el contenido del archivo:: " + err);
    });
  }

  public borrarCredencialLocal() {
    window.localStorage.removeItem(this._tokenController.token.credentialId.toString());
  }

  public salirBloqueo() {

    // this._spinner.hide();
    if (this._configurationControlService.esDemo) {
      this._router.navigate([this._configurationControlService.urlActual]);
    } else {
      this._router.navigate(["/login"]);
      window.location.reload();
    }
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /** Encargado de abrir el componente iframe con el pdf */
  downloadPdf(directory, fileName) {

    this._spinner.show();
    const rutaBase: string = CONFIG.RUTA_BASE;

    fetch(`${CONFIG.REST_END_POINT}downloadFile?rutabase=${rutaBase}&directorio=${directory}&nombreArchivo=${fileName}`, {
      method: 'GET',
      headers: new Headers({

      })
    })
      .then(response => response.blob())
      .then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = fileName + ".pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again
        this._spinner.hide();
      });
  }

  saveExamEvaluationItem() {
    this.respuesta = this._answerController.getRespuesta();

    let answer = new Answer(this.token.credentialId, this.actual.itemId, this._dateServerService.getDateServer(),
      this.respuesta, 'N', this.actual.sesion, this.actual.order,
      this._answerController.publicIp, this._answerController.open,
      this._answerController.marcarRespuesta);

    this.examEvaluationConfService.saveExamEvaluationItem(this.token.token, answer, this.token.tokenId);
    this._answerController.previousAnswer = this._answerController.respuesta;
    this._answerService.saveAnswer(answer);
  }

  finalizeSession() {
    let self = this;

    // Verificar que existan los datos necesarios
    if (!self._welcomeDataService.data || !self._welcomeDataService.data.sessions) {
      console.error('No hay datos de welcome disponibles');
      self._spinner.hide();
      self._router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    if (self.actual.sesion == self.welcomeData.sessions.length) {
      self._deleteService.deleteDatabase().then(result => {
        console.log('DELETE ITEMS DONE');
      });
    }
    self.sessionInfo.ipPublica = self._configurationControlService.publicIp;
    self.sessionInfo.fechaIngreso = new Date();
    self.sessionInfo.credencial = self._configurationControlService.credencial;
    self.sessionInfo.estado = ESTADO_SESSION_INFO.FINALIZA_PRUEBA;
    self._configurationControlService.sessionInfo.estado = ESTADO_SESSION_INFO.FINALIZA_PRUEBA;
    this._loginService.saveSessionInfo(this._tokenController.getTokenValue(), this._tokenController.token.tokenId, ESTADO_SESSION_INFO.FINALIZA_PRUEBA);
    self._loginService.changeSessionState(self.token.token, self.token.tokenId, self.token.credentialId.toString(), ESTADO_SESSION_INFO.FINALIZA_PRUEBA, self._configurationControlService.sessionInfo).then((res: any) => {
      let result = res == CodResp[0].codigo ? 'S' : 'N';
      if (result == 'S') {
        setTimeout(function () {
          caches.delete('precache-v4').then(res => {
            caches.delete('runtime').then(rta => {
              console.log("ejecutando postMessage Finish => plexiStop")
              let isFinished = true;
              if (self._configurationControlService.examConfiguration.multiplesesion) {
                isFinished = self._stateService.state.sesion == self._welcomeDataService.data.sessions.length
              } else {
                isFinished = true;
              }
              self._ltiService.idSessionStart = undefined;
              window.postMessage({ action: 'plexiStop', isFinished }, location.origin);
              self._configurationControlService.downloadFile = false;
              // Navegar con replaceUrl para evitar volver atrás
              self._router.navigate(['/endTest'], { replaceUrl: true }).then(() => {
                self._addComponent.contrast = false;
                self._addComponent.loadContrast();
                self._spinner.hide();
              }).catch(error => {
                console.error('Error navegando a endTest:', error);
                self._spinner.hide();
                // Si falla la navegación a endTest, ir directamente a login
                self._router.navigate(['/endTest']);
                self._addComponent.contrast = false;
                self._addComponent.loadContrast();
                self._spinner.hide();
              })
            });
          });
        }, 300);
      }
    });
  }
};
